// const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5040/api';
// const API_BASE = process.env.REACT_APP_API_URL || 'https://api.kartikgold.in/api';
// const API_BASE = process.env.REACT_APP_API_URL || 'https://backend.singhhimmat.in/api';
const API_BASE = process.env.REACT_APP_API_URL || 'https://manishbackend.riddhigold.in/api';

export const apiRequest = async (path, options = {}) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {})
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    headers,
    ...options
  });

  if (!response.ok) {
    let error = 'Request failed';
    try {
      const data = await response.json();
      error = data.error || error;
    } catch {
      error = response.statusText || error;
    }
    const err = new Error(error);
    err.status = response.status;
    throw err;
  }

  if (response.status === 204) return null;
  return response.json();
};

export const apiGet = (path) => apiRequest(path);
export const apiPost = (path, body) =>
  apiRequest(path, { method: 'POST', body: JSON.stringify(body) });
export const apiPut = (path, body) =>
  apiRequest(path, { method: 'PUT', body: JSON.stringify(body) });
export const apiDelete = (path) =>
  apiRequest(path, { method: 'DELETE' });

export const apiUpload = async (path, formData, method = 'POST') => {
  const token = localStorage.getItem('token');
  const headers = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    method,
    headers, // Added headers for Auth
    body: formData
  });

  if (!response.ok) {
    let error = 'Request failed';
    try {
      const data = await response.json();
      error = data.error || error;
    } catch {
      error = response.statusText || error;
    }
    const err = new Error(error);
    err.status = response.status;
    throw err;
  }

  if (response.status === 204) return null;
  return response.json();
};
